import { Pipe, PipeTransform } from '@angular/core'
import { imageUrl } from './common'
import { RestServices } from '../app/services/rest.services'
import { AuthService } from '../app/services/auth.services'

@Pipe({ name: 'getUrlImage' })
export class GetUrlImagePipe implements PipeTransform {
    constructor(private authData: AuthService, private restApi: RestServices) {
    }

    transform(value: string, typeImage: string = ''): any {
        let urlImg
        if (typeImage) {
            urlImg = imageUrl + value + '?type=' + typeImage
        } else {
            urlImg = imageUrl + value
        }
        return urlImg
    }
}



// WEBPACK FOOTER //
// ./src/helper/getUrlImage.pipe.ts